/**
 * A dataservice that provides access to back end file generation
 */
export class FileBuilderService {
  private excelResource: InterACT.Interfaces.IResource<any>;

  constructor(private $resource: ng.resource.IResourceService) {
    this.excelResource = $resource('api/file-builder/build-excel-file');
  }

  /**
   * Builds an excel file and returns the workbook data
   *
   * @param endpoint The endpoint to get the data from
   * @param qParam The query string or an array of query parts to be used for the data retreival
   * @param columns The list of columns for the file
   * @param locale The current locale in case of company name
   * @param fileType The type of file object expected back
   * @param title The title of the worksheet created
   * @returns The promise of the original server interaction
   */
  public buildExcelFile(
    endpoint: string,
    qParam: Array<any> | string | Object,
    columns: Array<any>,
    locale: string,
    fileType: string,
    title: string
  ) {
    const options = {
      endpoint: endpoint,
      q: qParam,
      columns: columns,
      locale: locale,
      fileType: fileType.toLowerCase(),
      title: title
    };
    return this.excelResource.save(options).$promise;
  }
}